import { Box, IconButton, Typography } from '@mui/joy';
import React from 'react'
import { MdCircleNotifications } from "react-icons/md";
import CloseIcon from '@mui/icons-material/Close';
import { useThemeContext } from '../../context/ThemeContext';

const notifications = [
  { notification: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum adipisicing elit. Tempora, a magnam sit quidem vel hic!', created: 'March 1, 2024', success: true, pending: false, argent: false },
  { notification: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum adipisicing elit. Tempora, a magnam sit quidem vel hic!', created: 'March 2, 2024', success: false, pending: true, argent: false },

  { notification: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum adipisicing elit. Tempora, a magnam sit quidem vel hic!', created: 'March 3, 2024', success: false, pending: false, argent: true },
  { notification: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum adipisicing elit. Tempora, a magnam sit quidem vel hic!', created: 'March 1, 2024', success: true, pending: false, argent: false },
  { notification: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum adipisicing elit. Tempora, a magnam sit quidem vel hic!', created: 'March 2, 2024', success: false, pending: true, argent: false },
  { notification: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.Lorem ipsum adipisicing elit. Tempora, a magnam sit quidem vel hic!', created: 'March 3, 2024', success: false, pending: false, argent: true }

];

const Notification = () => {
  const { isXs,isSM, isMD, isMd, isLg} = useThemeContext();

  return (
    <>
      <Box sx={{

        margin: '2rem auto',
        width: isSM ? '100%' : isMD ? '100%' : isMd ? '1003px' : '1003px',
       
      }}>

        <Typography variant='h1' sx={{ fontWeight: 'bold', fontSize: "34px", mb: 2, paddingLeft:isSM? '2rem' : isMD ?'2rem':0, }}>
          Notification
        </Typography>


        {
          !notifications && notifications.length() >= 0 ? '' :
            notifications.map((notification, index) => {
              return (
                <Box
                  key={index}

                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    justifyItems:'center',
                   
                    width: isSM ? '100%' : isMD ? '100%' : isMd ? '1003px' : '1003px',
                    height:isSM? '100%' : isMD ?'100%' :isMd ? '90px' :'90px',
                    padding:isSM? '1rem' : isMD ?'1rem':0,
                    borderBottom: '2px solid rgb(230, 230, 230)',
                  mt:2
                  }}
                >

                 
                  <MdCircleNotifications
                      fontSize={'50px'}
                      color={notification.success ? 'green' : notification.pending ? 'orange' : notification.argent ? 'red' : ''}

                    />

                  <Box sx={{ flex: 1, pl: 2 }}>
                    <Typography variant='h5' sx={{ fontWeight:500,fontSize: isXs? '12px': isSM? '12px': isMd? '18px': isLg? '22px': '22px', }}>
                      {notification.notification}
                    </Typography>
                    <Typography variant='body-sm' sx={{ fontWeight: 'bold' }}>
                      {notification.created}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      padding: "10px",
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'start',
                      textAlign: 'center',
                      boxShadow: 'none',
                  
                      width: isSM ? '50px' : isMD ? '50px' : isMd ? '150px' : '150px',
                      height:isSM? '100%' : isMD ?'100%' :isMd ? '50px' :'50px',
                    }}
                  >

                    <IconButton

                      aria-label="close"
                      sx={{
                        color: '#000',
                        backgroundColor: 'transparent',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        }
                      }}
                    >
                      <CloseIcon />
                    </IconButton>


                  </Box>

                </Box>
              )
            })
        }


      </Box>
    </>
  )
}

export default Notification;